module.exports = __webpack_public_path__ + "assets/img/1601_01.jpg?3a295d4b611d2ba2f6b50d12e118f838";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1601_01.jpg
// module id = 1095
// module chunks = 0